import { UserAvatarComponent } from '@app/shared/components/user-avatar/user-avatar.component';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SearchService } from '../../services/search/search.service';
import * as loginSelectors from '../../../root-store/login-store/login.selector';
import { Subscription, interval } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { EVENTS } from '@app/constants/events.constants';
import { UserConnectionService, UserService } from '@app/shared/services';
import { UserInviteComponent } from '../user-invite/user-invite.component';
import { UserInviteSuccessScreenComponent } from '@app/modules/relationship/components/dialogs/user-invite-success-screen/user-invite-success-screen.component';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonModule, NgIf, NgForOf, NgClass, NgStyle } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TruncateStrPipe } from '@app/shared/pipes/truncate-str.pipe';
import { ConnectRelationshipDialogComponent } from '../connect-relationship-dialog/connect-relationship-dialog.component';
@AutoUnsubscribe()
@Component({
    selector: 'connect-user',
    templateUrl: './connect-user.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      MatButtonModule,
      MatTooltipModule,
      UserAvatarComponent,
      ConnectRelationshipDialogComponent,
      TruncateStrPipe
    ]
})
export class ConnectUserComponent implements OnInit, OnDestroy {
  public dialogRef = inject(MatDialogRef<ConnectUserComponent>);
  private searchService = inject(SearchService);
  private cd = inject(ChangeDetectorRef);
  private store = inject(Store);
  public data = inject<any>(MAT_DIALOG_DATA);
  private toastr = inject(ToastrService);
  private _userService = inject(UserService);
  private userConnectionService = inject(UserConnectionService);
  private dialog = inject(MatDialog);

  searchInput = '';
  userInput = new UntypedFormControl('');
  delay = 600;
  searchResults = [];
  search_val = '';
  subscription = new Subscription();
  currentUser = null;
  connection_relationship_data: any = {};
  selectedRelationship = {
    id: 68,
    name: 'Client',
  };
  isLoading = false;
  searchText = '';
  selectedUser: any = [];

  constructor() {
    this.selectedUser = this.data.selectedUser;
  }

  ngOnInit(): void {
    if (this.data?.fromNetworkRegister) {
      // this.selectedRelationship = {
      //   id: this.selectedUser?.relationship_id,
      //   name: this.selectedUser?.relationship_name,
      // };
    }
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.currentUser = result;
        }
        this.cd.detectChanges();
      })
    );

    this.subscription.add(
      this.userInput.valueChanges
        .pipe(
          debounce(() => {
            this.isLoading = true;
            return interval(this.delay);
          })
        )
        .subscribe((value) => {
          this.isLoading = true;
          if (value.trim() == '') {
            this.searchResults = [];
            this.search_val = '';
            this.isLoading = false;
            return;
          } else {
            this.isLoading = true;
            this.search_val = value;
            const payload = {
              search_type: 'all',
              search_val: value,
              user_id: this.currentUser.id,
            };
            this.subscription.add(
              this.searchService.search(payload).subscribe((res) => {
                // this.searchResults = res.filter(
                //   (user) => user.relationship_name.toLowerCase() == 'husband' || user.relationship_name.toLowerCase() == 'wife'
                // );
                const { data } = res;
                if (!!this.data) {
                  const { existingItems } = this.data;
                  if (!!existingItems || (this.data?.existingUsers && (this.data?.fromAddVault || this.data?.fromLinkedTemplate))) {
                    const isNotInArrayA =
                      !this.data?.fromAddVault && !this.data?.fromLinkedTemplate
                        ? (itemB) => !existingItems.some((item) => item.user_id === itemB.user_id)
                        : (itemB) => !this.data?.existingUsers.some((item) => item.user_id === itemB.user_id);
                    // Use filter with the condition function
                    const filtered = data.filter(isNotInArrayA);
                    const newList = filtered.filter((item) => {
                      if (!item.relationship_name) return item;
                    });
                    this.searchResults = newList;
                  } else {
                    this.searchResults = data;
                  }
                } else {
                  this.searchResults = data;
                }

                this.isLoading = false;
                this.cd.detectChanges();
              })
            );
          }
          this.isLoading = false;
        })
    );
  }
  closeDialog() {
    this.dialogRef.close('clear');
  }
  clearSearch() {
    this.searchInput = '';
    this.search_val = '';
    this.searchResults = [];
    this.userInput.setValue('');
    this.cd.detectChanges();
  }
  handleRelationshipSearch(val) {
    this.searchText = val;
  }

  selectedRelationshipData;
  doSomething(selectedData) {
    selectedData.id ? (this.selectedRelationshipData = selectedData) : (this.selectedRelationshipData = null);
  }
  relationshipIdChanged(event) {
    return;
  }
  connectUser() {
    if (!this.selectedRelationshipData) return;
    const currentUserId = this.data?.linkedUserId ?? this.currentUser.id;
    const finaldata = {
      relationship_name: this.selectedRelationshipData.name,
      to_user_id: this.selectedUser?.id ?? this.selectedUser?.user_id,
      user_id: currentUserId,
      requested_user_id: this.selectedUser?.id ?? this.selectedUser?.user_id,
      relationship_id: this.selectedRelationshipData.id,
      status: this.data?.fromNetworkRegister ? 'pending' : '',
    };
    // if (params?.user.user_type == UserTypeEnum.Professional && this.current_user['user_type'] != UserTypeEnum.Professional) {
    //   finaldata['relationship_id'] = ClientUserRelationship.id;
    //   finaldata['relationship_name'] = ClientUserRelationship.name;
    // }
    this.subscription.add(
      this.userConnectionService.connectToUser(finaldata).subscribe(
        (res) => {
          const data = {
            isexistingUser: true,
            success: true,
            ...finaldata,
            FullName: this.selectedUser.name,
          };
          this.subscription.add(this.userConnectionService.sendRelationshipRequestNotification(finaldata).subscribe());
          if (this.data?.requestForAddedUserData) {
            delete data.user_id;
            delete data.FullName;
            data['user_id'] = this.selectedUser.id;
            data['name'] = this.selectedUser.user_first_name + ' ' + this.selectedUser.user_last_name;
            data['user_profile_image_url'] = this.selectedUser?.user_profile_image_url;
          }
          if (this.data?.fromNetworkRegister) {
            this.toastr.success(`Request sent successfully`);
          }
          this.dialogRef.close(data);
          this.trackEventsInMixPanel();
          // } else {
          //   this.dialogRef.close();
          // }
        },
        (error) => {}
      )
    );
  }
  inviteUser() {
    this.userInput.setValue('');
    const modalRef3 = this.dialog.open(UserInviteComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'full-window-dialog-2',
    });
    this.subscription.add(
      modalRef3.afterClosed().subscribe(
        (res) => {
          if (res && res['success'] == true) {
            if (res['isexistingUser']) {
              this.toastr.success(`Connection request has been sent to ${res.FullName}`);
            } else {
              const modalRef = this.dialog.open(UserInviteSuccessScreenComponent, {
                autoFocus: false,
                panelClass: 'full-window-dialog-2',
                data: res,
              });
            }
          }
        },
        (error) => {}
      )
    );
  }

  // openInviteDialog() {
  //   this.modalService.open(UserInviteComponent);
  // }

  trackEventsInMixPanel() {
    const events =
      this.data?.type === 'Immediate Family Members'
        ? [{ eventName: EVENTS.network_setup_immediate_family_add_change }]
        : this.data?.type === 'In-Laws'
        ? [{ eventName: EVENTS.network_setup_in_laws_add_change }]
        : this.data?.type === 'Extended Family Members'
        ? [{ eventName: EVENTS.network_setup_extended_family_add_change }]
        : this.data?.type === 'Other Relationships'
        ? [{ eventName: EVENTS.network_setup_other_relationship_add_change }]
        : this.data?.type === 'Service Providers'
        ? [{ eventName: EVENTS.network_setup_service_providers_add_change }]
        : this.data?.type === 'Staff'
        ? [{ eventName: EVENTS.network_setup_staff_add_change }]
        : [];
    this._userService.trackEventsInMixPanel(events).then((response) => {});
  }
  clearUser() {
    this.selectedUser = null;
    this.searchInput = '';
    this.search_val = '';
    this.userInput.setValue('');
    this.dialogRef.close('clear');
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this._userService.cleanupWorker();
  }
}
